<template>
    <div class="o-wrapper u-m-b7">
        <div class="o-grid o-grid--center">
            <div class="post__click o-grid__item u-width-10/12 u-width-full@s">
                <div class="post__related"><p>Related posts</p></div>
            </div>
        </div>
        <div class="o-grid">
            <div class="o-grid__item u-width-full">
                <div class="cards__wrapper" id="cards">
                    <div class="cards">
                        <post-card-api
                            v-for="card in cards"
                            :key="card.id"
                            :card="card"
                        ></post-card-api>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!--    <div class="o-wrapper u-m-b7">
        <div class="o-grid o-grid&#45;&#45;center" v-if="!!cards.length">
            <div class="c-post-click o-grid__item u-width-10/12 u-width-full@s">
                <div class="post__related"><p>Related posts</p></div>
                <div class="c-cards__related_content" data-cy="related-content">

                </div>
            </div>
            <a
                v-if="$root.user !== false"
                :href="'/post/create/' + $root.community.url"
                class="c-article__add"
            ></a>
            <a
                v-else
                @click.prevent="showMemberPanel"
                class="c-article__add"
            ></a>
        </div>
    </div>-->
</template>

<script>
import PostCardApi from "../PostCardApi.vue";
import MasonryStore from "../../configs/masonry-store";

export default {
    components: {
        PostCardApi,
    },
    data() {
        return {
            cards: [],
            masonry: MasonryStore
        };
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$http.post('/api/v1/posts/related', {
                communityId: this.$root.community.id,
                dyadeyId: this.$root.dyadey_id
            }).then(
                (response) => {
                    this.cards = response.data.cards;
                },
                (response) => {
                    console.log("Errored:");
                    console.log(response);
                }
            );
        },
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        },
    },
    mounted() {
        /*this.onCommunityScroll();
        this.$root.$on('update-cards', this.updateCards);
        this.$root.$on('reset-cards', this.resetCards);*/
    },
    updated() {
        //async(onYouTubeIframeAPIReady);
        this.$nextTick(() => {
            this.masonry.load();
        })
    },
};
</script>
